import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Tooltip, tooltipClasses } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedId } from "../../../../core/data/redux/commonSlice";
import { all_routes } from "../../../router/all_routes";
import ActionsDropdown from "../../../../core/common/crmComponents/ActionsDropdown";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import { toast } from "react-toastify";
import api from "../../../../utils/api";
import { useCallHandler } from "../../../../utils/hooks/useCallHandler";
import {
  ACCOUNTANT,
  CALLER,
  COMPANY_ADMIN,
  SUPER_ADMIN,
} from "../../../../core/data/constants/constant";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import { formatDealsData } from "../../../../utils/helpers/formatModulesData";
import { setFilterModel } from "../../../../core/data/redux/filterSlice";
import { customMuiDateFilter } from "../../../../utils/helpers/customMuiDateFilter";
import SocialMediaIcons from "../../../../core/common/crmComponents/SocialMediaIcons";
import useReminders from "../../reminders/hooks/useReminders";
import { FiClock } from "react-icons/fi";
import ZoomMeetingStatus from "../../../../core/common/crmComponents/zoomMeeting/ZoomMeetingStatus";
import { useFunctionalityAccess } from "../../../../core/common/wrapper/HasFunctionalityAccess";
import PostCallModal from "./PostCallModal";
import { MdOutlineContentCopy } from "react-icons/md";

const DealList = ({ dealsData, setFilteredData }) => {
  const route = all_routes;
  const allParams = getAllUrlParams();
  const queryString = new URLSearchParams(allParams).toString();
  const { reminders } = useReminders();
  // Function to check if a lead has a reminder
  const hasReminder = (dealId) => {
    return reminders?.some((reminder) => reminder.leadId === dealId);
  };
  const [isOpenPostCallModal, setIsOpenPostCallModal] = useState(false);
  const openModal = () => setIsOpenPostCallModal(true);
  const closeModal = () => setIsOpenPostCallModal(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const [selectedDealId, setSelectedDealId] = useState(null);
  const { mutate, isPending, isSuccess, isError } = useCallHandler(
    MODULES.DEALS,
    selectedDealId,
  );
  const hasZoomAccess = useFunctionalityAccess("zoomSetting");
  const hasCallPermission = useFunctionalityAccess("CallPermission");

  const filterModel = useSelector((state) => state.filter.filterModel);

  const processedRows = formatDealsData(dealsData);

  // Columns definition for the DataGrid
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 70,
      headerClassName: "sticky-column",
      cellClassName: "sticky-column",
      renderCell: (params) => (
        <ActionsDropdown
          params={params}
          module={MODULES.DEALS}
          path={route.dealsDetails}
        />
      ),
      sortable: false,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.createdTime
            ? convertToUTCString(params?.row?.createdTime)
            : convertToUTCString(params?.row?.lastActivityDate)}
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Client Name",
      width: 180,
      sortable: true,
      renderCell: (params) => {
        const dealDetailsUrl = `${route.dealsDetails.replace(
          ":id",
          params.row.id,
        )}?${queryString}`;

        return (
          <div className="d-flex align-items-center">
            {hasReminder(params.row.id) && (
              <FiClock
                className="me-2 flex-shrink-0"
                size={18}
                style={{
                  color: "#ff9900",
                }}
              />
            )}
            <Link
              className="text-capitalize list-link text-truncate"
              to={dealDetailsUrl}
              style={{
                maxWidth: "250px", // Adjust width as needed
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {params.row.firstName} {params.row.lastName}
            </Link>
          </div>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Phone",
      width: 160,
      renderCell: (params) => (
        <div className="d-flex align-items-center mb-3">
          {hasCallPermission && user?.agentId && user?.campaignName ? (
            <Tooltip
              placement="bottom"
              title="Click To Call / Copy"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                      {
                        marginTop: "0px", // Adjust this to reduce space
                        transform: "translateY(0px)",
                      },
                  },
                },
              }}
            >
              <button
                className="d-flex align-items-center nav-link border-0 bg-transparent"
                onClick={() => {
                  navigator.clipboard
                    .writeText(`${params?.row?.mobile}`)
                    .then(() => {
                      toast.success("Copied Link To Clipborad");
                    })
                    .catch((err) => {
                      toast.error("Failed To Copy Link");
                    });
                  if (!isPending) {
                    setSelectedDealId(params.id);
                    mutate(params?.row?.mobile);
                  }

                  openModal();
                }}
                disabled={isPending}
              >
                <div className="p-0 flex-shrink-0 text-primary me-2 fs-5">
                  {isPending && selectedDealId === params.id ? (
                    <i className="ti ti-loader spinner" />
                  ) : (
                    <i className="ti ti-phone" />
                  )}
                </div>
                ****{params?.row?.mobile.slice(-4) || "N/A"}{" "}
              </button>
            </Tooltip>
          ) : hasCallPermission ? (
            <a
              // href={`tel:${params?.row?.mobile}`}
              className="d-flex align-items-center nav-link border-0 bg-transparent "
              onClick={(e) => {
                navigator.clipboard
                  .writeText(`${params?.row?.mobile}`)
                  .then(() => {
                    toast.success("Copied Link To Clipborad");
                  })
                  .catch((err) => {
                    toast.error("Failed To Copy Link");
                  });
                e.preventDefault();
                setSelectedDealId(params.id);
                openModal();
                setTimeout(() => {
                  window.location.href = `tel:${params?.row?.mobile}`;
                }, 500); // Delay to allow modal to open or animate
              }}
            >
              <div
                className="p-0 flex-shrink-0 text-primary me-2 fs-5"
                onClick={() => {
                  navigator.clipboard
                    .writeText(`${params?.row?.mobile}`)
                    .then(() => {
                      toast.success("Copied Link To Clipborad");
                    })
                    .catch((err) => {
                      toast.error("Failed To Copy Link");
                    });
                  setSelectedDealId(params.id);
                  openModal();
                }}
              >
                <i className="ti ti-phone" />
              </div>
              ****{params?.row?.mobile.slice(-4) || "N/A"}{" "}
            </a>
          ) : (
            <p className="mb-0">
              {" "}
              ****{params?.row?.mobile.slice(-4) || "N/A"}
            </p>
          )}
          <button
            className="btn btn-sm btn-light ms-1"
            onClick={() => {
              navigator.clipboard
                .writeText(`${params?.row?.mobile}`)
                .then(() => {
                  toast.success("Number Copied to Clipborad");
                })
                .catch((err) => {
                  toast.error("Failed To Copy Number");
                });
            }}
          >
            <MdOutlineContentCopy size={18} />
          </button>
        </div>
      ),
    },
    {
      field: "",
      headerName: "Social Media",
      width: 100,
      sortable: true,
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-start align-items-center gap-2">
            <SocialMediaIcons
              platform="whatsapp"
              phoneNumber={`${params?.row?.mobile}`}
            />

            {hasZoomAccess && <ZoomMeetingStatus params={params} />}
          </div>
        );
      },
    },
    ...(hasCallPermission
      ? [
          {
            field: "currentStatus",
            headerName: "Status",
            width: 110,
            sortable: true,
            renderCell: (params) => (
              <span
                className={`badge badge-pill badge-status text-capitalize`}
                style={{
                  backgroundColor: `${params?.row?.currentStatusColor}`,
                }}
              >
                {params.value}
              </span>
            ),
          },
        ]
      : []),
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 150,
      sortable: true,
      renderCell: (params) => (
        <span>{params?.row?.paymentStatus || "N/A"}</span>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.description || "N/A"}
        </div>
      ),
    },
    {
      field: "city",
      headerName: "City",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.city || params?.row?.address?.city || "N/A"}
        </div>
      ),
    },
    {
      field: "productName",
      headerName: "Product Name",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.productName || "N/A"}
        </div>
      ),
    },
    {
      field: "language",
      headerName: "Language",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">{params?.row?.language || "N/A"}</div>
      ),
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.leadSource || "N/A"}
        </div>
      ),
    },
    {
      field: "referenceSource",
      headerName: "Reference Source",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.referenceSource || "N/A"}
        </div>
      ),
    },
    {
      field: "assignedTo",
      headerName: "Caller",
      width: 130,
      renderCell: (params) => (
        <div className="text-capitalize">{params?.row?.assignedTo}</div>
      ),
      sortable: true,
    },
    { field: "email", headerName: "Email", width: 210, sortable: true },
    {
      field: "probability",
      headerName: "Probability",
      width: 80,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.probability ? params?.row?.probability : "medium"}
        </div>
      ),
      sortable: true,
    },

    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 210,
      valueFormatter: (params) =>
        params.value ? convertToUTCString(params.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.lastActivityDate
            ? convertToUTCString(params?.row?.lastActivityDate)
            : convertToUTCString(params?.row?.createdTime)}
        </div>
      ),
    },
    {
      field: "leadCreatedTime",
      headerName: "Lead Created Time",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.leadCreatedTime
            ? convertToUTCString(params?.row?.leadCreatedTime, true)
            : "N/A"}
        </div>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      {/* DataGrid Table */}
      <DataGrid
        rows={processedRows}
        columns={columns.map((column) => ({
          ...column,
          headerClassName: "bg-light-200",
        }))}
        autoHeight
        hideFooter
        disableExtendRowFullWidth
        onStateChange={(state) => {
          const filteredRowIds = Object.entries(state.filter.filteredRowsLookup)
            .filter(([_, isVisible]) => isVisible === true)
            .map(([rowId]) => rowId); // Keep IDs as strings

          // Filter dealsData based on these IDs
          const filteredData = dealsData?.filter((row) =>
            filteredRowIds.includes(row?._id),
          );
          // Pass the filtered data to the parent
          // setFilteredData(filteredData);
        }}
        sx={{
          "& .sticky-column": {
            position: "sticky",
            right: 0,
            background: "white", // Prevents content from hiding under it
            zIndex: 100, // Keeps it on top
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "white",
            position: "sticky",
            top: 0,
            zIndex: 110,
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => dispatch(setFilterModel(newModel))}
        slots={{
          toolbar: GridToolbar, // Enable filter toolbar above the grid
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true }, // Hide Print Button
            csvOptions: { disableToolbarButton: true }, // Hide CSV Export
          },
        }}
      />
      <PostCallModal
        isOpen={isOpenPostCallModal}
        openModal={openModal}
        closeModal={closeModal}
        dealId={selectedDealId}
      />
    </div>
  );
};

export default DealList;
